import $ from 'jquery';
import { SearchResults } from 'cigna_csg_gsg_elasticsearch';
import customMainTpl from './views/custom-main-template.tpl.html';
import customResultsTpl from './views/custom-results.tpl.html';
import { getRegionLanguageSection } from '../../js/utils';

const { region, language } = getRegionLanguageSection(location.pathname);

$('.header-search-input').keyup((v) => {
  $('.header-search-btn').toggleClass('disabled', $(v.currentTarget).val().replace(/ /g, '').length <= 0);
});
$('.header-search-form').submit((a) => {
  a.preventDefault();
  $('.header-search-input').each((i, e) => {
    if ($(e).val().replace(/ /g, '').length > 0) {
      a.currentTarget.submit();
    }
  });
});

export default () => {
  if (document.querySelectorAll('[search-results]')) {
    SearchResults({
      INDEX_SITE: `index-cignaglobalhealth-${region}-${language}`,
      mainTemplate: customMainTpl,
      resultTemplate: customResultsTpl,
      displayForKeyword: true,
      pagingTop: false,
      pagingBottom: true,
    });
  }
};




// WEBPACK FOOTER //
// ./src/static/js/search/index.js